export enum FileUploadCode {
  SUCCESS = 'FILE_UPLOAD_SUCCESSFUL',
  NO_FILES = 'FILE_UPLOAD_NO_FILES',
  INVALID_FORMAT = 'FILE_UPLOAD_INVALID_FORMAT',
  TOO_MANY_FILES = 'FILE_UPLOAD_TOO_MANY_FILES',
  VALIDATION_ERROR = 'FILE_UPLOAD_VALIDATION_ERROR',
  DATABASE_ERROR = 'FILE_UPLOAD_DATABASE_ERROR',
  UNKNOWN_ERROR = 'FILE_UPLOAD_UNKNOWN_ERROR',
  FAILED = 'FILE_UPLOAD_FAILED',
}

interface ImageKitUploadedFileBase {
  fileId: string
  name: string
  size: number
  versionInfo: {
    id: string
    name: string
  }
  filePath: string
  url: string
  height?: number
  width?: number
  thumbnailUrl?: string
  AITags?: string[] | null
  description?: string | null
}

export interface ImageKitUploadedFileImage extends ImageKitUploadedFileBase {
  fileType: 'image'
  orientation?: number
}

export interface ImageKitUploadedFileVideo extends ImageKitUploadedFileBase {
  fileType: 'non-image' | 'video'
  bitRate?: number
  duration?: number
  videoCodec?: string
}

export type ImageKitUploadedFile =
  | ImageKitUploadedFileImage
  | ImageKitUploadedFileVideo

export const FILE_UPLOAD_TRANSLATION_KEYS: Record<FileUploadCode, string> = {
  [FileUploadCode.SUCCESS]: 'errors.file_upload_successful',
  [FileUploadCode.NO_FILES]: 'errors.file_upload_no_files',
  [FileUploadCode.INVALID_FORMAT]: 'errors.file_upload_invalid_format',
  [FileUploadCode.TOO_MANY_FILES]: 'errors.file_upload_too_many_files',
  [FileUploadCode.VALIDATION_ERROR]: 'errors.file_upload_validation_error',
  [FileUploadCode.DATABASE_ERROR]: 'errors.file_upload_database_error',
  [FileUploadCode.UNKNOWN_ERROR]: 'errors.file_upload_unknown_error',
  [FileUploadCode.FAILED]: 'errors.file_upload_failed',
}

export function getFileUploadTranslationKey(code: FileUploadCode): string {
  return FILE_UPLOAD_TRANSLATION_KEYS[code]
}

export interface FileUploadResponse {
  results: Array<{
    success: boolean
    media?: unknown
    error?: FileUploadCode
    fileName?: string
    file?: unknown
    errorType?: string
  }>
  hasErrors: boolean
  message: FileUploadCode
  files: string[]
}

export function isFileUploadSuccess(response: FileUploadResponse): boolean {
  return !response.hasErrors && response.message === FileUploadCode.SUCCESS
}

export function getFailedFileCount(response: FileUploadResponse): number {
  return response.files.length
}

export function getFailedFileNames(response: FileUploadResponse): string[] {
  return response.files
}
